import {FAILURE, PENDING, SUCCESS} from '../../constants'
import {useReducer} from 'react'
import _ from 'lodash'
import moment from 'moment'

const ActionTypes = {
  FAILURE,
  PENDING,
  SUCCESS,
  RESET: 'RESET',
  SET_VIEW: 'SET_VIEW',
  REMOVE_EVENT_VIA_ID: 'REMOVE_EVENT_VIA_ID',
}
const InitialState = {
  viewData: {selectedView: null, selectedFilteredView: null},
  data: [],
  sidebarData: [],
  errors: null,
  isLoading: false,
}

const Reducer = (state = InitialState, action) => {
  switch (action.type) {
    case ActionTypes.REMOVE_EVENT_VIA_ID:
      state.data = state.data.filter(f => f.id !== action.payload.id)

      return {
        ...state,
        data: [...state.data],
        allEventsData: state.allEventsData,
      }
    case ActionTypes.SET_VIEW:
      return {
        ..._.cloneDeep(InitialState),
        viewData: action.payload.viewData
          ? action.payload.viewData
          : action.payload.shareableViewData,
        allEventsData: state.allEventsData,
      }
    case ActionTypes.RESET:
      return _.cloneDeep(InitialState)
    case PENDING:
      return {
        ...state,
        isLoading: true,
        error: null,
      }
    case SUCCESS:
      const {_data, eventsData} = eventsDataList(state, action)
      return {
        ...state,
        isLoading: false,
        errors: null,
        data: _data,
        allEventsData: eventsData,
        mydata: action.payload.events,
      }
    case FAILURE:
      return {
        ...state,
        errors: action.payload.errors,
        isLoading: false,
      }
    default:
      return state
  }
}

const useReservationEventsReducer = (state = InitialState) => {
  return useReducer(Reducer, state)
}

export default useReservationEventsReducer
export {ActionTypes, InitialState, Reducer}

const processData = (viewData, events) => {
  // SystemReservationAction
  // ReservationAction
  // GroupDateField
  // ActionDateField
  if (_.isEmpty(events)) return []
  let color = viewData?.selectedView?.group_view.color
  const {selectedFilteredViews} = viewData
  let _events = events.map(e => {
    if (!_.isEmpty(selectedFilteredViews)) {
      if (selectedFilteredViews.length > 1) {
        if (!_.isEmpty(selectedFilteredViews)) {
          if (selectedFilteredViews.length > 1) {
            const colorResult = getFilteredViewColor(e, selectedFilteredViews)
            if (!_.isEmpty(colorResult)) {
              color = colorResult
            }
          } else {
            color = selectedFilteredViews[0]?.color || 'green'
          }
        }
      } else {
        color = selectedFilteredViews[0]?.color || 'green'
      }
    }

    let ev = {
      id: e.id,
      title: e.reservation_uid ? e.reservation_uid : e.field_name,
      resourceId: e.id,
      bgColor: color,
      start: null,
      end: null,
      field_name: e.field_name,
      resourceName: e.reservation_uid ? 'Reservation Action' : e.display_name,
      reservation_uid: e.reservation_uid,
      reserved_for: e.reserved_for,
      items: e.items,
      entity_id: viewData?.selectedView?.group_view?.entity_id,
      type: e.type,
      display_name: e.display_name,
      status: e.status,
      state: e.state,
      action_return_date: e?.action_return_date || null,
      entity_key: e.entity?.key,
      is_shareable_view: e.is_shareable_view ? e.is_shareable_view : false,
      is_stamp: e.is_stamp,
      display_name_first: e.display_name ? e.display_name : '',
      display_with_secondary: e.display_with_secondary ? e.display_with_secondary : '',
      display_name_third: e.display_name_third ? e.display_name_third : '',
    }

    if (['GroupDateField'].indexOf(e.type) !== -1) {
      ev = {
        ...ev,
        entity_object_id: e?.entity_object_id,
      }
    }

    if (['DefaultAction', 'ActionDateField', 'ReservationAction'].indexOf(e.type) !== -1) {
      ev = {
        ...ev,
        entity_action_id: e.entity_action_id,
        entity_display_name: e.entity_display_name,
        entity_display_with_secondary: e.entity_display_with_secondary,
        group_values: e.group_values,
        action_values: e.action_values,
        entity_object_id: e?.entity_object_id,
      }
    }

    if (e.start_date) {
      ev.start = moment(e.start_date)
    }
    if (e.end_date) {
      ev.end = moment(e.end_date)
    }
    return ev
  })

  return _events
}

const getFilteredViewColor = (data, colorViews) => {
  let itemColor = ''
  _.each(colorViews, function(viewColor) {
    const colorFilters = viewColor?.filters || []
    const filter = []
    _.each(colorFilters, function(filterItem) {
      const item_value = []
      _.each(filterItem?.values || [], function(filterValue) {
        if (data) {
          const dataFilter = _.get(data, `group_values.${filterItem.key}`)
          if (typeof dataFilter === 'object') {
            if (_.isEqual(dataFilter?.display_name, filterValue.value) && _.isEmpty(itemColor)) {
              itemColor = viewColor.color
            }
          } else {
            if (_.isEqual(dataFilter, filterValue.value) && _.isEmpty(itemColor)) {
              item_value.push(true)
              return
            } else if (dataFilter) {
              if (dataFilter.split('!#!').includes(filterValue.value)) {
                item_value.push(true)
                return
              }
            }
          }
        }
      })
      filter.push(item_value.includes(true))
    })

    if (!filter.includes(false)) {
      itemColor = viewColor.color
    }
  })

  if (_.isEmpty(itemColor)) {
    return colorViews[0]?.color
  } else {
    return itemColor
  }
}

export const eventsDataList = (state, action) => {
  let _data = [...state.data]
  const data = processData(state.viewData, action.payload.events)
  const eventsData = [...data]
  // combine and app  allEventsData: [],

  if (_.isEqual(action.payload.view_data, state.viewData)) {
    _.each(data, d => {
      // find similar
      const same = _data.find(
        f =>
          (d.id === f.id && d.field_name === f.field_name) ||
          (!!f.reservation_uid && f.reservation_uid === d.reservation_uid)
      )
      if (same) {
        // add non existing events
        const non_exist_events = _.differenceWith(d.events, same.events, (a, b) => a.id === b.id)
        if (non_exist_events.length > 0) {
          same.events = [...same.events, ...non_exist_events]
        }
      } else {
        _data.push(d)
      }
    })
  }
  return {_data, eventsData}
}
